import { useEffect, useState } from 'react';
import { Cargando } from '@/shared/ui/Cargando';

const PASOS = [
  { hasta: 800, titulo: 'Firmando el comprobante', detalle: 'Con el certificado de la empresa' },
  { hasta: 2500, titulo: 'Enviando al SRI', detalle: 'Recepción del comprobante' },
  {
    hasta: 8000,
    titulo: 'Obteniendo respuesta',
    detalle: 'Consultando la autorización',
  },
  {
    hasta: Number.MAX_SAFE_INTEGER,
    titulo: 'El SRI está tardando',
    detalle: 'Sigue en proceso: no cierre esta ventana',
  },
] as const;

export function EsperandoAlSri() {
  const [transcurrido, setTranscurrido] = useState(0);

  useEffect(() => {
    const arranque = Date.now();
    const reloj = setInterval(() => setTranscurrido(Date.now() - arranque), 300);
    return () => clearInterval(reloj);
  }, []);

  const paso = PASOS.find((p) => transcurrido < p.hasta) ?? PASOS[PASOS.length - 1]!;

  return (
    <div
      role="alertdialog"
      aria-busy="true"
      aria-label="Comunicándose con el SRI"
      className="fixed inset-0 z-50 grid place-items-center bg-armazon-900/40 p-4 backdrop-blur-sm"
    >
      <div className="w-full max-w-md">
        <Cargando titulo={paso.titulo} detalle={paso.detalle} alto="h-32" />
      </div>
    </div>
  );
}
